"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contain = void 0;
var _fit = require("./fit");
var contain = (0, _fit.fit)(true);
exports.contain = contain;